module.exports = __webpack_public_path__ + "static/media/about6.b9a2e0f1.jpg";